import { VSelect } from 'vuetify/lib/components/index.mjs';

export const selectDefaults: Partial<VSelect> = {
  variant: 'solo',
  flat: true,
  opened: true,
  density: 'comfortable',
  listProps: {
    bgColor: `rgb(var(--v-theme-surface-container))`,
    class: ['d-flex', 'flex-column', 'ga-2'],
  },
  menuProps: {
    zIndex: 99999,
  },
};
